import {
  MENTION_ALL_ID,
  MENTION_ALL_TOKEN,
  extractMentionsFromText,
  getMentionDisplayLabel,
  getOwnerDisplayLabel,
  toMentionToken,
} from "./annotationMentions";

const MENTION_MARKUP_REGEX = /@\[([^\]]+)\]\(([^)]+)\)/g;

export const getMentionsPlainText = (markup = "") =>
  markup.replace(MENTION_MARKUP_REGEX, (_match, display) => `@${display}`);

export const convertMentionsMarkupToStorage = (markup = "") =>
  markup.replace(MENTION_MARKUP_REGEX, (_match, display, id) => {
    if (id === MENTION_ALL_ID) {
      return MENTION_ALL_TOKEN;
    }

    if (id.startsWith("legacy:")) {
      return `@${display}`;
    }

    return toMentionToken({ id, type: "user" });
  });

export const convertStorageToMentionsMarkup = ({
  text = "",
  ownersByID = {},
  t,
  allLabelKey,
}) => {
  if (!text) return "";

  const mentions = extractMentionsFromText({
    text,
    ownersByID,
    t,
    allLabelKey,
  });

  if (mentions.length === 0) {
    return text;
  }

  let result = text;

  [...mentions]
    .sort((left, right) => right.start - left.start)
    .forEach((mention) => {
      const display =
        getMentionDisplayLabel({
          mention,
          ownersByID,
          t,
          allLabelKey,
        }) || text.slice(mention.start, mention.end).replace(/^@/, "");

      let id = mention.userID;

      if (mention.type === "all") {
        id = MENTION_ALL_ID;
      } else if (mention.type === "legacy") {
        const entry = Object.entries(ownersByID).find(
          ([, owner]) => getOwnerDisplayLabel({ owner }) === mention.label
        );
        id = entry ? entry[0] : `legacy:${mention.label}`;
      }

      const markup = `@[${display}](${id})`;
      result =
        result.slice(0, mention.start) + markup + result.slice(mention.end);
    });

  return result;
};
